export default __webpack_public_path__ + "static/media/Affiliates.f7563682.xlsx";